import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { CommonService } from "../services/common.service";
@Component({
	selector: "app-thanks-promotor",
	templateUrl: "./thanks-promotor.component.html",
	styleUrls: ["./thanks-promotor.component.scss"],
})
export class ThanksPromotorComponent implements OnInit {
	lang;
	centro;
	constructor(
		private router: Router,
		private route: ActivatedRoute,
		private common: CommonService
	) {
		this.lang = localStorage.getItem("idioma");
		this.route.params.subscribe(async (parameter: any) => {
			console.log(parameter);
			this.centro = parameter.centro;
		});
	}
	ngOnInit(): void {}
	redirect() {
		this.common.setClick();
		window.open(
			"https://www.google.com/search?q=consejo+profesional+de+ciencias+economicas+de+santa+fe&sca_esv=e126eb4d051b0442&sxsrf=AE3TifMgRWJI38Vf3qE80WsxxXqq_SS-9g%3A1757512966440&ei=BoXBaLjWGuaNwbkP09zagQY&oq=consejo+profesional+de+ciencias+economicas+de+san&gs_lp=Egxnd3Mtd2l6LXNlcnAiMWNvbnNlam8gcHJvZmVzaW9uYWwgZGUgY2llbmNpYXMgZWNvbm9taWNhcyBkZSBzYW4qAggBMgUQABiABDIFEAAYgAQyBRAAGIAEMgUQABiABDIFEAAYgAQyBRAAGIAEMgYQABgWGB4yBhAAGBYYHjIGEAAYFhgeMgYQABgWGB5IxxpQrglYwxBwAXgBkAEAmAHNAaABwAiqAQUwLjYuMbgBAcgBAPgBAZgCCKAC4AjCAgoQABiwAxjWBBhHwgINEAAYgAQYsAMYQxiKBcICGRAuGIAEGLADGNEDGEMYxwEYyAMYigXYAQHCAhkQLhiABBiwAxhDGMcBGMgDGIoFGK8B2AEBwgILEC4YgAQYxwEYrwHCAggQABiABBiiBJgDAIgGAZAGEboGBggBEAEYCJIHBTEuNi4xoAfQQbIHBTAuNi4xuAfcCMIHBTAuMS43yAcc&sclient=gws-wiz-serp#"
		);
	}
}
